import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Typography from '@material-ui/core/Typography';

interface ISimpleStat {
    label: any;
    labelType: 'string' | 'component';
    value: number;
    component?: any;
    route: string;
    disabled?: boolean;
    subLabel?: any;
}
const useStyles = makeStyles(theme => ({
    link: {
        color: theme.palette.primary.main,
        paddingRight: theme.spacing(1),
        textAlign: 'right',
    },
}));
const SimpleStat = (props: ISimpleStat) => {
    const classes = useStyles();

    return (
        <Grid container data-custom="SimpleStat" justify="space-between">
            <Grid alignItems="center" container item justify="flex-start" xs={9}>
                {props.labelType === 'string' && (
                    <Link className={classes.link} to={props.route}>
                        {<Typography variant="subtitle1">{props.label}</Typography>}
                    </Link>
                )}
                {props.labelType === 'component' && props.component}
            </Grid>
            <Grid container item justify="flex-end" xs={3}>
                {!props.disabled && (
                    <Link className={classes.link} to={props.route}>
                        <Typography variant="h4">{props.value}</Typography>
                    </Link>
                )}
            </Grid>
        </Grid>
    );
};

export default SimpleStat;
